import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/shift-away.css'
import 'tippy.js/themes/light-border.css'

import { Controller } from '@hotwired/stimulus'
import tippy from 'tippy.js'

// Connects to data-controller="info-tooltip"
export default class extends Controller {
  static targets = [
    'triggerElement',
  ]

  declare readonly triggerElementTarget: HTMLElement

  static values = {
    content: String,
    dialogId: String
  }

  declare contentValue: string
  declare dialogIdValue: string
  declare hasDialogIdValue: boolean

  connect () {
    if (this.hasDialogIdValue && this.dialogIdValue) {
      const dialog = document.getElementById(this.dialogIdValue)
      if (dialog) {
        tippy(this.triggerElementTarget, {
          content: this.contentValue,
          theme: 'light-border',
          animation: 'shift-away',
          arrow: true,
          placement: 'top',
          appendTo: dialog
        })
        return
      }
    }

    tippy(this.triggerElementTarget, {
      content: this.contentValue,
      theme: 'light-border',
      animation: 'shift-away',
      arrow: true,
      placement: 'top',
    })
  }
}
